export const ROLES = {
  PRICING_USER: "pricing-user",
  STORE_MANAGER: "store-manager",
  RULE_AUDIT: "rule-audit",
  PRODUCT_AUDIT: "product-audit",
  RULE_APPROVER: "rule-approver",
  DISCOUNT_ADMIN: "discount-admin",
};

// Normalizes a role string by trimming whitespace and stripping any
// surrounding quotes (the user profile API can return roles like `"pricing-user"`).
export const normalizeRole = (role) =>
  typeof role === "string" ? role.trim().replace(/^"+|"+$/g, "") : role;

export const hasAnyRole = (userRoles, allowedRoles) => {
  if (!allowedRoles || allowedRoles.length === 0) return true;
  if (!Array.isArray(userRoles)) return false;
  const normalizedUserRoles = userRoles.map(normalizeRole);
  return allowedRoles.some((role) => normalizedUserRoles.includes(role));
};
